import { render, staticRenderFns } from "./AreaDescription.vue?vue&type=template&id=102442f7&scoped=true"
import script from "./AreaDescription.vue?vue&type=script&lang=js"
export * from "./AreaDescription.vue?vue&type=script&lang=js"
import style0 from "./AreaDescription.vue?vue&type=style&index=0&id=102442f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102442f7",
  null
  
)

export default component.exports